import { createSelector } from 'reselect'
import { formValueSelector as getFormValueSelector } from 'redux-form'
// @ts-ignore
import { isFieldTouched } from 'shared/reduxForm'
import { getData, getFetchSucceeded, getPending, getPrevData } from 'loankeeper-common/helpers/SimpleFetchManager'
import { translate } from './helpers'
import { appsFetchSucceded, getApplicationsCount } from 'src/store/application'

export const formValueSelector = (state, { instanceName }, field) => getFormValueSelector(instanceName)(state, field)

export const isFormFieldTouched = (state, { instanceName }, field) => isFieldTouched(instanceName)(state, field)

export const getAppsFetching = (state, { instanceName }) => getPending(instanceName)(state) || false

export const getAppsPrevData = (state, { instanceName }) => getPrevData(instanceName)(state)

export const getApplications = createSelector(
  getAppsFetching,
  (state, { instanceName }) => getData(instanceName)(state),
  getAppsPrevData,
  (appsFetching, appsData, appsPrevData) => (!appsFetching ? appsData : appsPrevData) || [],
)

export const getAppsFetchSucceeded = (state, { instanceName }) => getFetchSucceeded(instanceName)(state) || false

// export const getApplicationsCount = createSelector(getApplications, (applications) =>
//   applications ? applications.length : 0,
// )

// export const getTitle = createSelector(
//   getAppsFetchSucceeded,
//   getApplicationsCount,
//   (appsFetchSucceeded, applicationsCount) => {
//     let name = translate('frm_application')

//     if (appsFetchSucceeded) {
//       name = `${translate('lbl_app_cap')} ${applicationsCount} ${translate('lbl_app_cap_rec')}`
//     }

//     return name
//   },
// )

export const getTitle = createSelector(
  appsFetchSucceded,
  getApplicationsCount,
  (appsFetchSucceeded, applicationsCount) => {
    let name = translate('frm_application')
    if (appsFetchSucceeded) {
      name = `${translate('lbl_app_cap')} ${applicationsCount} ${translate('lbl_app_cap_rec')}`
    }

    return name
  },
)
